// libraries.
import { FieldErrors } from "react-hook-form";

// utils.
import { formatPrice } from "@utils/formatPrice.utils";

interface Props {
  errors: FieldErrors;
  pricePerM2: number;
}

export const MinPriceFooter = ({ pricePerM2, errors }: Props) => {
  return (
    <>
      <div className="d-flex justify-content-end w-100">
        <small className="text-white">
          Valor por m²: {formatPrice(pricePerM2) || 0}
        </small>
      </div>
      {errors.minPublicationPrice && (
        <small className="d-flex justify-content-end text-danger fw-bold">
          {String(errors.minPublicationPrice.message)}
        </small>
      )}
    </>
  );
};
